module.exports = __webpack_public_path__ + "img/ll.a394ee9f.png";